<script>
import { useMessage } from '@/hooks/useMessage'
import SearchForm from '@/components/SearchForm/index.vue'
import AppView from '@/components/AppView.vue'
import SuperTable from '@/components/SuperTable.vue'
import { reactive, ref, onMounted, computed } from '@vue/composition-api'
import { useTable } from '@/hooks/useTable'
import { getPage, deleteConfig, updateSorts, getAppList } from './service'
import Add from './components/Add.vue'

export default {
  name: 'KanbanBoard',
  components: {
    SearchForm,
    AppView,
    SuperTable,
    Add,
  },
  setup() {
    const { message, confirm } = useMessage()
    const tableRef = ref(null)
    const editVisible = ref(false)
    const systemList = ref([])
    const searchForm = reactive({
      appId: null,
    })

    const searchConfig = computed(() => [
      { el: 'VSelect', props: 'appId', label: '所属系统', maxlength: 50, items: systemList.value, clearable: searchForm.appId !== null },
    ])

    const tableColumns = ref([
      { props: 'sort', label: '', width: 60, format: () => {}, dragSort: true },
      { props: 'name', label: '看板名称', minWidth: 250 },
      { props: 'appName', label: '所属系统', minWidth: 150 },
      { props: 'roleNames', label: '分配角色', minWidth: 250 },
      { props: 'operation', label: '操作', width: 160, fixed: 'right' },
    ])
    const { init, search, page, handleSizeChange, handleCurrentChange, tableData, loading } = useTable({
      api: getPage,
      initParam: searchForm,
      dataCallBack: data => ({
        data: {
          records: data.data,
          total: data.total,
        },
      }),
    })

    function reset() {
      searchForm.appId = null
      search()
    }
    function getSystemLists() {
      getAppList().then(({ data }) => {
        if (data.status === 200) {
          const obj = { text: '全部', value: null }
          const sys = data.data.map(item => ({ text: item.name, value: item.appId }))
          sys.unshift(obj)
          const tablesys = tableColumns.value.find(item => item.props === 'appId')
          if (tablesys) tablesys.enum = sys
          systemList.value = sys
        }
        init()
      })
    }

    const rowItem = ref({})

    const rowDragConfig = {
      async dragEndMethod(val, index) {
        console.log(val, index)

        // if (!searchForm.appId) {
        //   message.warning('请选择系统')

        //   return false
        // }

        return true
      },
    }

    function rowDragendEvent(val) {
      const { newIndex, oldIndex } = val._index
      const { pageIndex, pageSize } = page.value

      if (newIndex === oldIndex) return message.warning('拖拽后的排序位置与拖拽前一致，请重新排序')

      updateSorts({ ...searchForm, id: val.oldRow.id, sorts: (pageIndex - 1) * pageSize + newIndex }).then(({ data }) => {
        if (data.status === 200) {
          message.success('排序成功')
        }
      }).catch(error => message.error(error.response.data.message))
    }
    function edit(row) {
      rowItem.value = row
      editVisible.value = true
    }

    function del(row) {
      confirm('确定删除吗？', '删除', { type: 'error' }).then(() => {
        deleteConfig({ id: row.id }).then(({ data }) => {
          if (data.status === 200) {
            message.success('删除成功')
            search()
          }
        }).catch(error => message.error(error.response.data.message))
      })
    }

    onMounted(() => {
      init()
      getSystemLists()
    })

    return {
      searchForm,
      searchConfig,
      tableColumns,
      search,
      page,
      handleSizeChange,
      handleCurrentChange,
      tableData,
      loading,
      systemList,
      editVisible,
      rowItem,
      edit,
      del,
      rowDragendEvent,
      tableRef,
      rowDragConfig,
      init,
      reset,
    }
  },
}
</script>

<template>
  <app-view>
    <template #header>
      <SearchForm :columns="searchConfig" :value="searchForm" :search="search" :reset="reset" />
    </template>

    <template #main-header>
      <div class="main-header-btns">
        <v-btn color="primary" @click="edit({})">
          新增看板
        </v-btn>

        <span class="fs14">可拖动调整前台展示顺序</span>
      </div>
    </template>

    <SuperTable
      ref="tableRef"
      :columns="tableColumns"
      :data="tableData"
      :loading="loading"
      :row-config="{drag: true}"
      :row-drag-config="rowDragConfig"
      @row-dragend="rowDragendEvent"
    >
      <template #operation="{ row }">
        <span class="app-link" @click="edit(row)">编辑</span>
        <span class="app-link" @click="del(row)">删除</span>
      </template>
    </SuperTable>

    <template #footer>
      <vl-pagination
        :page-size="page.pageSize"
        :page-sizes="page.pageSizes"
        :page-index="page.pageIndex"
        :total="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>

    <Add v-if="editVisible" title="看板配置" :row-item="rowItem" :list="systemList" @close="editVisible = false" @refresh="init" />
  </app-view>
</template>

<style scoped lang="scss">
.main-header-btns{
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
</style>
